// @flow

import { Component, createElement } from 'react';
import PropTypes from 'prop-types';
import {
  locationFromHref,
  enrichLocation
} from '@seek/seek-jobs-seo/build/location';

import hoistNonReactStatic from 'hoist-non-react-statics';

function getEnrichedLocation(
  location: string | UrlLocation,
  baseLocation: string
) {
  // If location is an href string then coerce to a location object
  return typeof location === 'string'
    ? locationFromHref(location, baseLocation)
    : enrichLocation(location, baseLocation);
}

type Props = {
  location?: UrlLocation
};

export function provideEnrichedLocation(WrappedComponent: any) {
  class WithEnrichedLocation extends Component<Props> {
    static contextTypes = {
      store: PropTypes.shape({
        getState: PropTypes.func.isRequired
      }).isRequired
    };

    render() {
      const { location } = this.props;
      const { location: locationStore } = this.context.store.getState();

      // If location is undefined pass it through as undefined
      const enrichedLocation =
        typeof location !== 'undefined'
          ? getEnrichedLocation(location, locationStore.url)
          : location;

      const mergedProps = {
        ...this.props,
        location: enrichedLocation
      };

      return createElement(WrappedComponent, mergedProps);
    }
  }
  return hoistNonReactStatic(WithEnrichedLocation, WrappedComponent);
}
